require("./main.less");
document.addEventListener("DOMContentLoaded", function(event) {
    //do work
    console.log("hello from main.js");
});


// WEBPACK FOOTER //
// ./src/main.js